import React from 'react'
import Orders from '../components/all-orders/Orders'
import Navbar from '../components/Navbar'
import useFetchUser from "../custom-hooks/useFetchUser";

export default function OrderPage() {
    const data = useFetchUser();
    return (
        <div className='App'>
            <Navbar userData={data}/>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                <div style={{height: "70vh", minWidth: "90vw"}}>

                    <Orders/>
                </div>
            </div>
        </div>
    )
}
